import { Flex } from "antd";

import styles from "./index.module.scss";

export const StatusLabel = ({
  status,
  customLabel,
  className,
}: {
  status: boolean | undefined;
  customLabel?: string;
  className?: string;
}) => {
  if (status) {
    return (
      <div className={`${styles.active} ${!status && styles.active_disable} `}>
        {customLabel || "فعال"}
      </div>
    );
  } else {
    return (
      <div
        className={`${styles.deactive} ${status && styles.deactive_disable}`}
      >
        {customLabel || "غیر فعال"}
      </div>
    );
  }
};
